import PropTypes from 'prop-types';
import Textarea from "components/form/Textarea/Textarea";
import { useEffect, useState } from "react";
import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import useData from "hooks/useData";
import useComment from "hooks/useComment";
import Trans from "features/translation/components/Trans";
import CheckProfileVisible from "pages/Profile/CheckProfileVisible";
import Checkbox from "components/form/Checkbox/Checkbox";
import Loader from "components/ui/Loader/Loader";
import ImageUpload from "components/form/ImageUpload/ImageUpload";

const CommentCreateUpdate = ({ id, entityId, parentId, isOwner, onCompleted }) => {
  const { comment, isLoading } = useComment(id);
  const { hideDialog } = useDialog();
  const { getData, postData, patchData, deleteData } = useData();
  const [ saving, setSaving ] = useState(false);
  const [ error, setError ] = useState();
  const [ body, setBody ] = useState();
  const [ imageData, setImageData ] = useState();
  const [ following, setFollowing ] = useState(id ? undefined : true);

  useEffect(
    () => {
      if (id && comment && !body) {
        setBody(comment.comment_body && comment.comment_body.value);
      }

      const checkFollowing = async () => {
        const result = await getData(`rest/bulletin/${ entityId }/follow`);
        setFollowing(result.data?.id !== null);
      }
      if (comment) {
        checkFollowing();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ comment ]);

  const onSave = async () => {
    if (!body) {
      setError('Bericht is een verplicht veld');
      return;
    }

    setError();
    setSaving(true);

    let saveData = {
      ...comment,
      entity_id: { target_id: entityId },
      field_comment_image: { target_id: imageData && imageData.fid[0].value },
      comment_body: { value: body },
    };

    if (parentId) {
      saveData.pid = parentId;
    }

    const updating = comment?.id;

    let response;
    if (updating) {
      response = await patchData(comment.id, 'comment', saveData, false);
    } else {
      response = await postData('rest/comment', saveData, false);
    }

    // Add or remove the "following" flag (no error handling required for now)
    if (following) {
      await postData(`rest/bulletin/${ entityId }/follow`);
    } else if (id || isOwner) {
      await deleteData(`rest/bulletin/${ entityId }/follow`);
    }

    const result = await response?.json();
    if (response?.status === 200 || response?.status === 201) {
      hideDialog();
      if (onCompleted) {
        onCompleted(result);
      }
    } else {
      setError(result?.message || `Het opslaan van de reactie is mislukt (${ response?.status })`);
    }

    setSaving(false);
  };

  const followCheckbox = (
    following === undefined
      ?
      <Loader/>
      :
      <div className={ `dialog__row` }>
        <Checkbox label={ `follow` } id="follow" checked={ following } onChange={ event => setFollowing(event.target.checked) }>
          Stuur mij een e-mail als er nieuwe reacties zijn
        </Checkbox>
      </div>
  );

  const form = (
    <>
      <div className={ `dialog__row` }>
        <Trans
          text={ 'Uw reactie is zichtbaar voor andere leden. Als u dit niet wilt kunt u een privébericht naar de organisator sturen.' }/>
      </div>
      <div className={ `dialog__row` }>
        <h3>Uw reactie</h3>
        <Textarea onChange={ event => setBody(event.target.value) } value={ body } autoFocus/>
      </div>
      <div className={ `dialog__row` }>
        <ImageUpload title={ `Foto bij deze reactie` }
                     subtitle={ `(niet verplicht)` }
                     type="comment"
                     bundle="default"
                     field="field_comment_image"
                     currentData={ imageData }
                     currentValue={ comment?.field_comment_image?.value }
                     onUploaded={ setImageData }/>
      </div>
      { followCheckbox }
      <div className="dialog__buttons dialog__buttons--end">
        <Button onClick={ onSave } variant="secondary">{ id ? 'Opslaan' : 'Reageren' }</Button>
      </div>
    </>
  );

  return (
    <Dialog title={ comment?.id ? 'Reactie aanpassen' : 'Reageren' }
            loading={ isLoading || saving }
            errorMessage={ error }
            warnOnClose={ true }>
      <CheckProfileVisible>
        { form }
      </CheckProfileVisible>
    </Dialog>
  )
}

CommentCreateUpdate.propTypes = {
  id: PropTypes.number,
  entityId: PropTypes.number.isRequired,
  parentId: PropTypes.number,
  isOwner: PropTypes.bool,
  onCompleted: PropTypes.func,
}

export default CommentCreateUpdate;
